import { render, staticRenderFns } from "./PrivateDataDefault.vue?vue&type=template&id=07c9b50a&"
import script from "./PrivateDataDefault.vue?vue&type=script&lang=js&"
export * from "./PrivateDataDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports